export default {
  init: () => {},
  captureException: () => {},
};